<template>
  <div class="identity-backdrop">
    <div class="identity-card">
      <div class="identity-card__brand">
        <div class="auto-auction-logo" aria-label="AutoAuction.com">
          <span class="auto-auction-logo__auto">Auto</span><span class="auto-auction-logo__auction">Auction</span><span class="auto-auction-logo__top-level-domain">.com</span>
        </div>
      </div>
      <div class="identity-card__actions">
        <template v-if="errorMessage">
          <h1 class="identity-card__title">{{ t('authentication.login.failedTitle') }}</h1>
          <p class="identity-card__lede">{{ errorMessage }}</p>
          <button class="button button--primary" type="button" @click="retry">
            {{ t('authentication.login.retryButton') }}
          </button>
          <button class="identity-card__walkaway" type="button" @click="signOut">
            {{ t('authentication.linking.notNowLink') }}
          </button>
        </template>
        <template v-else>
          <div class="identity-card__spinner" aria-hidden="true" />
          <h1 class="identity-card__title">{{ t('authentication.login.signingInTitle') }}</h1>
          <p class="identity-card__lede">{{ t('authentication.login.signingInLede') }}</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import '../shared/identity-card.css';
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { brokeredLogin, loginFailureMessageKey, pendingLogin, sessionTokenStorage } from '@hds/identity-client-sdk';

defineOptions({ name: 'BeginLoginPage' });

// The desktop arrival screen — the same two moments as the mobile one, in the
// identity card: the instant before the on-load redirect to the hosted login
// (ADR 0003), and the retry screen when a round trip failed. The retry button
// is deliberate — auto-retrying a failed return would loop forever.
//
// Failure copy never paints a raw protocol code or a JSON body; see
// loginFailureMessageKey. The portal boot path logs the machine code.

const route = useRoute();
const { t } = useI18n();

const errorMessage = computed(() => {
  const key = loginFailureMessageKey(route.query.error);
  return key ? t(key) : '';
});

onMounted(() => {
  if (!errorMessage.value) {
    brokeredLogin.beginLogin('/');
  }
});

function retry() {
  brokeredLogin.beginLogin('/');
}

async function signOut() {
  await sessionTokenStorage.clearSession();
  pendingLogin.clearPendingLogin();
  // Terminal: end the provider's own session too, or the next on-load
  // login silently returns the same failing identity.
  brokeredLogin.beginLogout();
}
</script>

<style scoped>
/* The shared card skin lives in ../shared/identity-card.css. */
</style>
